<mat-toolbar class="service-unavailable" color="warn">
  <span>Google Service Unavailable</span>
</mat-toolbar>
